import { useMemo } from 'react';
import { ClientConfigName, ClientConfigs } from '../../lib/Util';
import { User } from '../../system/User';

export function useRepresentadoRRHHConfig(user?: User) {

  const configRepresentadoRRHH = useMemo<ClientConfigs | undefined>(() => {
    if (!user) return undefined;
    const profileId = user.getProfile().getId();
    if (!profileId) return undefined;
    return user.getClientConfigs().find((c) => c.cltconf_perid === profileId && c.cltconf_nombre === ClientConfigName.OPC_REPRESENTADO_RRHH);
  }, [user]);

  return configRepresentadoRRHH;
}
